import { render, staticRenderFns } from "./Asset.vue?vue&type=template&id=459a02d8&scoped=true"
import script from "./Asset.vue?vue&type=script&lang=ts"
export * from "./Asset.vue?vue&type=script&lang=ts"
import style0 from "./Asset.vue?vue&type=style&index=0&id=459a02d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459a02d8",
  null
  
)

export default component.exports